'use strict';

angular.module('openDataApp')
  .controller('AccountForm', ['$scope', '$q', '$timeout', 'ApiService', function ($scope, $q, $timeout, ApiService) {

    $scope.accountSettings = {
      email: $scope.$parent.account.email,
      contact: $scope.$parent.account.contact,
      phone: $scope.$parent.account.phone,
      kvk: parseInt($scope.$parent.account.kvk, 10),
      ipadres: ($scope.$parent.account.ipadres === "" ? undefined : $scope.$parent.account.ipadres.split(','))
    };
    $scope.originalAccountSettings = JSON.parse(JSON.stringify($scope.accountSettings));

    $scope.editingAccount = false;
    $scope.toggleAccountEdit = function () {
      $scope.editingPassword = false;
      if ($scope.editingAccount) {
        $scope.accountSettings = JSON.parse(JSON.stringify($scope.originalAccountSettings));
      }
      $scope.editingAccount = !$scope.editingAccount;
    };

    $scope.editingPassword = false;
    $scope.togglePasswordEdit = function () {
      $scope.editingPassword = !$scope.editingPassword;
    };

    $scope.submit = function(formData) {
      if (!$scope.greatSucces) {
        $scope.submitting = true;
        $scope.accountFormSubmitError = null;

        var def = $q.defer();

        ApiService.updateAccount(formData)
          .then(
            function success() {
              $scope.originalAccountSettings = JSON.parse(JSON.stringify(formData));
              
              if (!$scope.editingPassword) {
                $scope.greatSuccess = true;
                $scope.submitting = false;
                $scope.editingAccount = false;
                $timeout(function () {
                  $scope.greatSuccess = false;
                }, 2000);
                def.resolve();
              } else {
                ApiService.updatePassword({
                  email: $scope.originalAccountSettings.email,
                  oldPassword: formData.oldPassword,
                  newPassword: formData.newPassword
                })
                .then(
                  function success() {
                    $scope.greatSuccess = true;
                    $scope.submitting = false;
                    $scope.editingAccount = false;
                    $scope.editingPassword = false;
                    $timeout(function () {
                      $scope.greatSuccess = false;
                    }, 2000);
                    def.resolve();
                  },
                  function error(response) {
                    if (response.status === 401) {
                      $scope.accountFormSubmitError = 'Het oude wachtwoord komt niet overeen.';
                    } else {
                      $scope.accountFormSubmitError = response.data.error !== undefined ? response.data.error : 'Er is iets misgegaan, probeer het later nog eens.';
                    }
                    $scope.submitting = false;
                    def.reject();
                  }
                );
              }
            },
            function error(response) {
              $scope.submitting = false;
              $scope.accountFormSubmitError = response.data.error !== undefined ? response.data.error : 'Er is iets misgegaan, probeer het later nog eens.';
              def.reject();
            }
          );

        return def.promise;
      }
    };
  }]);
